/**
 * Origine d'une tentative (Attempt).
 * Définit le contexte dans lequel l'utilisateur a démarré la tentative.
 */
export enum AttemptOrigin {
  /**
   * Pratique libre - L'utilisateur a démarré la tentative de sa propre initiative
   */
  FREE_PRACTICE = 'FREE_PRACTICE',

  /**
   * Assignation enseignement - Tentative démarrée via une assignation à une classe/enseignement
   */
  TEACHING_ASSIGNMENT = 'TEACHING_ASSIGNMENT',

  /**
   * Assignation utilisateur - Tentative démarrée via une assignation directe à l'utilisateur
   */
  USER_ASSIGNMENT = 'USER_ASSIGNMENT',

  /**
   * Diagnostic - Tentative démarrée dans un contexte de diagnostic/évaluation
   */
  DIAGNOSTIC = 'DIAGNOSTIC',
}

